<template>

    <div class="form">
        <SCACreateSubscriptionPaymentRequestButton
                :stripe-public-key="stripePublicKey"
                :stripe-account-id="stripeAccountId"
                :orderId="orderId"
                :payment-request-options="paymentRequestOptions"
                @valid="paymentRequest = true"
                @emit-global-loading="globalLoadingHandler"
                :subdomain="subdomain"
        />
        <hr class="hr-text mt-3" data-content="Or pay with card" v-if="paymentRequest">
        <SCACreateSubscriptionCardForm
                :payment-request-options="paymentRequestOptions"
                :stripe-public-key="stripePublicKey"
                :stripe-account-id="stripeAccountId"
                :orderId="orderId"
                @emit-global-loading="globalLoadingHandler"
        />
    </div>

</template>

<script>
import SCACreateSubscriptionCardForm from './SCACreateSubscriptionCardForm';
import SCACreateSubscriptionPaymentRequestButton from './SCACreateSubscriptionPaymentRequestButton';

export default {
  name: 'SubscriptionPayments',
  data() {
    return {
      loading: false,
      paymentRequest: false,
    };
  },
  props: {
    stripePublicKey: {
      type: String,
      required: true,
    },
    stripeAccountId: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: false,
    },
    paymentRequestOptions: {
      required: true,
      type: Object,
    },
    subdomain: {
      required: true,
      type: String,
    },

  },
  methods: {
    globalLoadingHandler(e) {
      this.$emit('emit-global-loading', e);
    },
  },

  components: {
    SCACreateSubscriptionPaymentRequestButton,
    SCACreateSubscriptionCardForm,
  },

  beforeMount() {

  }
};
</script>

<style scoped lang="scss">
    .form {
        background-color: #f6f9fc;
        padding: 12px;
        padding-top: 24px;
    }

    .form * {
        font-family: Inter UI, Open Sans, Segoe UI, sans-serif;
        font-size: 16px;
        font-weight: 500;
    }

    .hr-text {
        line-height: 1em;
        position: relative;
        outline: 0;
        border: 0;
        color: black;
        text-align: center;
        height: 1.5em;
        opacity: .5;

        &:before {
            content: '';
            // use the linear-gradient for the fading effect
            // use a solid background color for a solid bar
            background: linear-gradient(to right, transparent, #818078, transparent);
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 1px;
        }

        &:after {
            content: attr(data-content);
            position: relative;
            display: inline-block;
            color: black;

            padding: 0 .5em;
            line-height: 1.5em;
            // this is really the only tricky part, you need to specify the background color of the container element...
            color: #2a2a2a;
            background-color: #fcfcfa;
        }

    }

</style>
